<template>
    <van-popup class="share-change-group-popup share-save-group-popup" 
        v-bind:value="showPop" 
        v-bind:close-on-click-overlay="overlayClickClose"
        @click-overlay='clickOverlay'>
        <div class="share-cgpp-title">{{setting[shareType].title}}</div>
        <div class="share-cgpp-item">
            <label class="collate-form-label">{{setting[shareType].label}}</label>
            <input class="collate-form-input" type="text" maxlength="20" v-bind:placeholder="setting[shareType].placehold" @input="changeParentName" v-model="shareFormData.shareTitle" autofocus>
        </div>
        <div class="share-cgpp-button" @click="clickConfirm">{{setting[shareType].saveText}}</div>
    </van-popup>
</template>

<script>
export default {
    name: 'VantShareSavePop',
    props: [
        'shareType', 
        'showPop',
        'overlayClickClose',
        'overlayFunc',
        'shareFormData',
        'changeParentNameFunc',
        'confirmFunc'
    ],
    data() {
        return {
            setting: {
                '3': {
                    title: '确定要保存的批盘名称',
                    label: '批盘名称',
                    placehold: '输入批盘名称',
                    saveText: '确定'
                },
                '6': {
                    title: '确定要保存的论盘名称',
                    label: '论盘名称',
                    placehold: '输入论盘名称',
                    saveText: '确定并进入论盘'
                }
            },
            confirmLock: false
        }
    },
    methods: {
        clickOverlay() {
            if(this.overlayFunc && typeof(this.overlayFunc) == 'function') {
                this.overlayFunc();
            }
        },
        changeParentName() {
            if(this.changeParentNameFunc && typeof(this.changeParentNameFunc) == 'function') {
                this.changeParentNameFunc();
            }
        },
        clickConfirm() {
            var me = this;
            if(this.confirmLock) {
                return;
            }
            this.confirmLock = true;

            if(this.confirmFunc && typeof(this.confirmFunc) == 'function') {
                this.confirmFunc({
                    cb: function() {
                        me.confirmLock = false;
                    }
                });
            }
        }
    }
}
</script>